import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { UnsupportedBrowserPopup } from './models/unsupported-browser-modal.models';

@Component({
  selector: 'idp-unsupported-browser-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './unsupported-browser-modal.component.html',
  styleUrls: ['./unsupported-browser-modal.component.scss']
})
export class UnsupportedBrowserModalComponent implements AfterViewInit {
  @ViewChild('modal') modal?: ElementRef<HTMLDialogElement>;
  @Input() content: UnsupportedBrowserPopup = {} as UnsupportedBrowserPopup;
  @Output() dismissModal = new EventEmitter<void>();
  browserNotSupportedReason = false;

  ngAfterViewInit() {
    this.modal?.nativeElement.showModal();
  }

  open() {
    this.modal?.nativeElement.showModal();
  }

  toggleBrowserNotSupportedReason() {
    this.browserNotSupportedReason = !this.browserNotSupportedReason;
  }

  unSupportedBrowserClose() {
    this.modal?.nativeElement.close();
    this.dismissModal.emit();
  }
}
